module.exports = __webpack_public_path__ + "img/Weapon_230.8470d1f0.png";